import { REDUCER } from '../reducers/reducersConst';

/**
 * THEME DATA REDUCER
 */
let initialState = {
  pinCodesRevealOpen: false,
  student: undefined,
  openedReveal: false
};

/**
 * Theme Reducer for reveals
 * @param state
 * @param action
 * @returns {*}
 */
export let reveal = (state = initialState, action) => {
  switch (action.type) {
    case REDUCER.REVEAL.OPEN_PINS_REVEAL:
      return {
        ...state,
        pinCodesRevealOpen: true,
        student: action.student
      };
    case REDUCER.REVEAL.CLOSE_PINS_REVEAL:
      return {
        ...state,
        pinCodesRevealOpen: false
      };
    case REDUCER.REVEAL.SET_OPENED_REVEAL:
      return {
        ...state,
        openedReveal: action.openedReveal
      };
    case REDUCER.REVEAL.OPEN_DISABLE_EVALUATIONS_REVEAL:
      return {
        ...state,
        disableEvaluationsRevealOpen: action.open,
        task: action.task
      };
    case REDUCER.REVEAL.OPEN_DISABLE_COMMENT_REVEAL:
      return {
        ...state,
        disableCommentRevealOpen: action.open,
        task: action.task
      };
    case REDUCER.REVEAL.DISABLE_EVALUATIONS_REVEAL:
      return {
        ...state,
        disableEvaluations: action.disable
      };
    case REDUCER.REVEAL.OPEN_STUDENTS_WITH_FILES_REVEAL:
      return {
        ...state,
        studentsWithFilesRevealOpen: action.open,
        students: action.students
      };
    case REDUCER.REVEAL.STUDENTS_WITH_FILES_CONFIRMATION:
      return {
        ...state,
        studentsWithFilesConfirmation: action.confirmation
      };

    case REDUCER.REVEAL.OPEN_STUDENTS_WITHOUT_ASSIGNMENT_IN_LESSONS:
      return {
        ...state,
        studentsWithoutAssignmentInLessons: action.open,
        students: action.students,
        sendObject: action.sendObject
      };

    case REDUCER.REVEAL.SET_CUSTOM_CONFIRM_MODAL_OPENED:
      return {
        ...state,
        customConfirmModalObject: action.customConfirmModalObject
      };
    case REDUCER.REVEAL.SET_LINKED_BOOK_MODAL_OPENED:
      return {
        ...state,
        linkedBookModalObject: action.linkedBookModalObject
      };
    case REDUCER.REVEAL.OPEN_TASK_WITHOUT_STUDENTS_OF_THIS_GROUP:
      return {
        ...state,
        tskWithoutStudentsOfThisGroup: action.open
      };

    default:
      return state;
  }
};
